export const smsA = {
  icon: 'fas fa-mobile-alt',
  text: 'crud_SMS',
  link: 'sms',
  submenue: [
    { icon: 'fas fa-mobile', text: 'sms_indivi', link: 'individuel' },
    { icon: 'fas fa-mobile-alt', text: 'sms_multi', link: 'multiple' },
  ],
}
